
import axios from "axios";

const getDetailsPageWiseURL = 'https://vg6cldsgp3.execute-api.ap-south-1.amazonaws.com/test'

export function apiCallingPost(postData) {
  return axios.post(getDetailsPageWiseURL, postData)
    .then((data) => data)
    .then((res) => res)
}
